import { inject, Injectable, signal } from '@angular/core';
import { IConstantes } from '../interfaces/app.inteface';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  constantes = signal<IConstantes | null>(null);
  private apiURL: string = `${API_URL}/constantes/`;

  private http = inject(HttpClient);

  getConstants(): Observable<IConstantes> {
    return this.http.get<IConstantes>(this.apiURL);
  }

}
